import React, { useRef } from 'react';
import useConstellationEngine from './useConstellationEngine';

const canvasStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  pointerEvents: 'none',
  zIndex: 0,
  background: 'transparent',
};

const counterWrapperStyle = {
  position: 'fixed',
  top: 16,
  right: 16,
  zIndex: 5,
  pointerEvents: 'none',
};

const counterStyle = {
  padding: '8px 12px',
  borderRadius: 12,
  background: 'rgba(10, 15, 28, 0.6)',
  color: '#ddecff',
  fontSize: 13,
  letterSpacing: '0.4px',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.35)',
  border: '1px solid rgba(125, 207, 255, 0.35)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
};

function TrafficConstellationsCanvas({
  canvasClassName = '',
  canvasTestId = undefined,
  counterClassName = '',
  counterTestId = undefined,
  drawBackgroundOverlay = true,
  opacity = 0.95,
  showCounter = true,
}) {
  const canvasRef = useRef(null);
  const { guestCount, isDisabled } = useConstellationEngine(canvasRef, {
    drawBackgroundOverlay,
  });
  const resolvedOpacity = Number.isFinite(Number(opacity))
    ? Math.min(Math.max(Number(opacity), 0), 1)
    : 0.95;

  return (
    <>
      <canvas
        ref={canvasRef}
        className={canvasClassName}
        data-testid={canvasTestId}
        style={{
          ...canvasStyle,
          opacity: isDisabled ? 0 : resolvedOpacity,
        }}
        aria-hidden="true"
      />
      {showCounter ? (
        <div
          style={counterWrapperStyle}
          className={`traffic-counter ${counterClassName}`.trim()}
          data-testid={counterTestId}
        >
          <div style={counterStyle}>
            {guestCount} Visitors at the Galaxy Gate
          </div>
        </div>
      ) : null}
    </>
  );
}

export default TrafficConstellationsCanvas;
